// TravelersExcelExportButton.js - Versión definitiva optimizada
import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const TravelersExcelExportButton = ({ travelers = [], service }) => {
    const [loading, setLoading] = useState(false);

    const formatTramo = (tramo) => {
        if (tramo === "IDA") return "SUBIDA";
        if (tramo === "VUELTA") return "BAJADA";
        return tramo || "-";
    };

    const normalizeEstadoViaje = (t) => {
        if (t.estadoreporte === "NO_VIAJO") return "NO VIAJÓ";
        if (t.estadoreporte === "VIAJO") return "VIAJÓ";
        if (t.estadoreporte === "RESERVADO") return "RESERVADO";
        if (t.estadoreporte === "NO_ASIGNADO_A_MANIFIESTO") return "SIN MANIFIESTO";
        return t.estadoreporte || t.ordserdetestpas || "-";
    };

    const handleExport = async () => {
        if (!travelers.length) return;
        
        setLoading(true);
        
        try {
            // IMPORTACIÓN DINÁMICA - Solo se carga cuando se necesita
            const XLSX = await import("xlsx");
            
            const workbook = XLSX.utils.book_new();
            
            // Resumen
            const total = travelers.length;
            const totalSubida = travelers.filter((t) => t.ordserdettra === "IDA").length;
            const totalBajada = travelers.filter((t) => t.ordserdettra === "VUELTA").length;
            const totalViajaron = travelers.filter((t) => t.estadoreporte === "VIAJO").length;
            const totalNoViajaron = travelers.filter((t) => t.estadoreporte === "NO_VIAJO").length;
            const totalSinManifiesto = travelers.filter((t) => !t.manid).length;
            const manifiestos = new Set(travelers.filter((t) => t.manid).map((t) => t.manid));
            
            const resumenRows = [
                ["REPORTE DE VIAJEROS"], [],
                ["Orden de servicio", service?.ordsercabid || ""],
                ["Nombre", service?.ordsercabnom || ""],
                ["Estado", service?.ordsercabest || ""], [],
                ["Indicador", "Cantidad"],
                ["Total pasajeros", total],
                ["Total subida", totalSubida],
                ["Total bajada", totalBajada],
                ["Total viajaron", totalViajaron],
                ["Total no viajaron", totalNoViajaron],
                ["Total sin manifiesto", totalSinManifiesto],
                ["Total manifiestos/unidades", manifiestos.size],
            ];
            
            const resumenSheet = XLSX.utils.aoa_to_sheet(resumenRows);
            resumenSheet["!cols"] = [{ wch: 30 }, { wch: 35 }];
            XLSX.utils.book_append_sheet(workbook, resumenSheet, "Resumen");
            
            // Función para crear sheets
            const createSheet = (data, sheetName) => {
                const rows = data.map((t, index) => ({
                    Item: index + 1,
                    DNI: t.perdni || "",
                    Apellidos: t.perape || "",
                    Nombres: t.pernom || "",
                    Tramo: formatTramo(t.ordserdettra),
                    Manifiesto: t.manid || "",
                    Unidad: t.maninf || "",
                    "Punto de subida": t.puntosubida || "",
                    "Punto de bajada": t.puntobajada || "",
                    "Estado OS": t.ordserdetestpas || "",
                    "Estado viaje": normalizeEstadoViaje(t),
                }));
                
                const worksheet = XLSX.utils.json_to_sheet(rows);
                worksheet["!cols"] = [
                    { wch: 8 }, { wch: 14 }, { wch: 24 }, { wch: 24 },
                    { wch: 14 }, { wch: 12 }, { wch: 24 }, { wch: 28 },
                    { wch: 28 }, { wch: 18 }, { wch: 18 },
                ];
                worksheet["!autofilter"] = { ref: `A1:K${Math.max(rows.length + 1, 2)}` };
                worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
                
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            };
            
            // Crear sheets
            createSheet(travelers.filter((t) => t.ordserdettra === "IDA"), "SUBIDA");
            createSheet(travelers.filter((t) => t.ordserdettra === "VUELTA"), "BAJADA");
            createSheet(travelers.filter((t) => t.estadoreporte === "NO_VIAJO"), "No viajaron");
            
            // Exportar
            XLSX.writeFile(workbook, `reporte_viajeros_os_${service?.ordsercabid || "orden"}.xlsx`);
            
        } catch (error) {
            console.error("Error al exportar Excel:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            variant="contained"
            color="success"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadIcon />}
            onClick={handleExport}
            disabled={!travelers.length || loading}
            sx={{
                transition: "all 0.3s",
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 12px rgba(46, 125, 50, 0.3)",
                },
            }}
        >
            {loading ? "Exportando..." : "Exportar Excel"}
        </Button>
    );
};

export default TravelersExcelExportButton;